import Axios from "axios";
import {
    SET_INVENTORY_DETAILS_LIST,
    UNSET_INVENTORY_DETAILS_LIST,
    SET_INVENTORY_BATCH_LIST,
    UNSET_INVENTORY_BATCH_LIST,
  } from "@/store/mutation-types";
import { getInventoryDetailsList, getInventoryBatchList } from "@/store/api";

// initial state
const state = {
  inventoryDetailsList: [],
  inventoryBatchList: [],
};

const getters = {
  getInventoryDetailsList(state) {
    return state.inventoryDetailsList;
  },
  getInventoryBatchList(state) {
    return state.inventoryBatchList;
  }
};

const mutations = {
  [SET_INVENTORY_DETAILS_LIST](state, data) {
    state.inventoryDetailsList = data;
  },
  [UNSET_INVENTORY_DETAILS_LIST](state) {
    state.inventoryDetailsList = [];
  },
  [SET_INVENTORY_BATCH_LIST](state, data) {
    state.inventoryBatchList = data;
  },
  [UNSET_INVENTORY_BATCH_LIST](state) {
    state.inventoryBatchList = [];
  }
};

const actions = {
  getInventoryDetailsList({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(getInventoryDetailsList, { params })
        .then(function (response) {
          commit('SET_INVENTORY_DETAILS_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_INVENTORY_DETAILS_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInventoryBatchList({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(getInventoryBatchList, { params })
        .then(function (response) {
          commit('SET_INVENTORY_BATCH_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_INVENTORY_BATCH_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

